module.exports = __webpack_public_path__ + "img/MESTNA OBCINA MARIBOR.2a5add55.png";